var App = App || {};

App.Speedbump = (function ($) {
    "use strict";

    var uriSchemes = ["javascript:", "mailto:", "tel:"];

    function getExclusions() {
        return window.Speedbump && Array.isArray(window.Speedbump.exclusions)
            ? window.Speedbump.exclusions
            : [];
    }

    function init() {
        $(document).on("click", "a", function (e) {
            var $this = $(this),
                url = $this.attr("href"),
                exclusions = getExclusions();
                const speedbumpForWesterly = url && url.toLowerCase().indexOf('westerlyccu.com') !== -1 && url.toLowerCase().indexOf('@westerlyccu.com') === -1;

            if ($this.attr("id") === "sbModalSubmit") {
                e.preventDefault();

                window.open(url);
                $("#sbModal").modal("hide");
            }

            else if (this.hostname !== location.hostname
                && $.inArray(this.hostname, exclusions) === -1
                && url
                && url.indexOf("#") !== 0
                && !isUriSchema(url)
                && !speedbumpForWesterly) {

                e.preventDefault();
                $("#sbModal").modal("show");
                $("#sbModalSubmit").attr("href", url);
            }
        });
    }

    function isUriSchema(url) {
        for (var i in uriSchemes) {
            if (url.indexOf(uriSchemes[i]) > -1) {
                return true;
            }
        }
        return false;
    }

    return {
        init: init
    };
})(jQuery);

$(function () {
    App.Speedbump.init();
});